import type { SurveyKey } from '~/types/surveys'
import { surveyMap } from '~/composables/useSurvey'
import { useUsersStore } from '#imports'

export default defineNuxtRouteMiddleware((to) => {
  const surveyKeyParam = to.query.survey as SurveyKey | undefined

  if (!surveyKeyParam) {
    if (import.meta.client) {
      const surveys = useUsersStore().specificUser?.surveys ?? []

      if (surveys.length === 1) {
        const surveyKey = surveys[0].surveyKey

        return navigateTo({
          name: 'account-vragenlijst',
          query: { survey: surveyKey }
        })
      } else {
        return navigateTo({
          name: 'account'
        })
      }
    }
    // Fallback to client if we're rendering on the server
    return
  }

  if (!(surveyKeyParam in surveyMap)) {
    showError({
      status: 404
    })
    return abortNavigation()
  }
})
